import type { ActionContext } from 'vuex';

import { findInsertionById } from '@/store/insertions/InsertionsStore';
import type { InsertionFunnelState } from '@/store/types/insertion-funnel-store';
import { useAgencyStore } from '@/stores/agency/useAgencyStore';
import { useUserStore } from '@/stores/user/useUserStore';

type InsertionOwnerResolutionContext = Pick<
  ActionContext<unknown, InsertionFunnelState>,
  'rootState' | 'rootGetters'
>;

/**
 * Resolves the owner id used to scope an insertion refetch.
 *
 * The Manage Ads list is the authoritative source. `fallbackUserId` and the active
 * agency person cover the flows that reach the store before that list exists, for
 * example a poll started right after a wizard publish.
 */
export const resolveInsertionOwnerId = (
  context: InsertionOwnerResolutionContext,
  insertionId: string,
  fallbackUserId?: string,
): string | undefined =>
  findInsertionById(context.rootState.insertions?.insertions ?? [], insertionId)?.userId ??
  fallbackUserId ??
  useAgencyStore().activeAgencyPersonId ??
  (useUserStore().logonId || undefined);
